var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pp_logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 181.566,
    height: 48.73,
    viewBox: "0 0 181.566 48.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 33.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M370.439,223.945a4.23,4.23,0,0,1-2.274,3.586c-.05.027-.1.054-.154.079a4.23,4.23,0,0,1-4.73-.606,4.176,4.176,0,0,1-1.307-2.776L364,223.77a2.231,2.231,0,1,0,4.455.245,2.231,2.231,0,0,0-1.462-2.04l-.027-.014c-.057-.025-.113-.052-.172-.073l-.016-.007-1.929-.81-.17-.073a3.837,3.837,0,0,1-.885-.536,3.37,3.37,0,0,1-1.3-2.626,3.567,3.567,0,0,1,2.41-3.239,4.137,4.137,0,0,1,5.107,1.972l-1.559.946c.036-.023-.25-.449-.279-.488a2.108,2.108,0,0,0-.42-.408,2.207,2.207,0,0,0-.962-.4,2.094,2.094,0,0,0-1.72.463,1.6,1.6,0,0,0,.313,2.526,9.639,9.639,0,0,0,1.142.47q.565.232,1.13.465a5.522,5.522,0,0,1,1.77,1.08,3.428,3.428,0,0,1,.976,2.013A4.18,4.18,0,0,1,370.439,223.945Z",
    transform: "translate(-188.874 -213.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M288.822,214.446H285.7v13.245h1.984v-5.37h1.135a4.723,4.723,0,0,0,2.964-.962,3.665,3.665,0,0,0,1.332-2.975C293.119,215.694,291,214.446,288.822,214.446Zm1.627,5.524a2.611,2.611,0,0,1-1.582.481h-1.18v-4.135h1.18a2.045,2.045,0,0,1,2.306,2.068A1.9,1.9,0,0,1,290.45,219.97Z",
    transform: "translate(-285.704 -213.536)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 1.984,
    height: 13.247,
    transform: "translate(23.069 0.909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M336.768,216.43v-1.984h-7.3v13.247h7.3v-1.984h-5.319v-4.286h5.156v-1.984h-5.156V216.43Z",
    transform: "translate(-230.146 -213.537)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M316.608,220.836h-5.5v1.986h3.259s-.109.517-.123.565a4.258,4.258,0,0,1-.191.524,3.66,3.66,0,0,1-.552.881,3.884,3.884,0,0,1-1.636,1.117,3.988,3.988,0,0,1-2.553.161,4.865,4.865,0,0,1-1.918-.965,5.026,5.026,0,0,1-1.8-3.4c-.007-.079-.011-.163-.018-.245s0-.17,0-.256,0-.173,0-.256.011-.168.018-.245a4.939,4.939,0,0,1,4.675-4.494,1.668,1.668,0,0,1,.184-.007,4.853,4.853,0,0,1,4.106,2.295l1.049-1.049.354-.354a6.845,6.845,0,0,0-5.191-2.751c-.1-.009-.211-.011-.318-.011s-.211,0-.316.011a6.868,6.868,0,0,0,0,13.722c.1.009.211.011.316.011.12,0,.238,0,.354-.011s.213-.011.32-.023c.061,0,.123-.011.186-.02a.968.968,0,0,0,.109-.016c.064-.007.125-.018.188-.029a.8.8,0,0,0,.125-.023,5.9,5.9,0,0,0,4.741-5.136,9.318,9.318,0,0,0,.134-1.614v-.372Z",
    transform: "translate(-263 -213.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M328.186,214.045l-4.625,10.138-4.626-10.138L316.225,228.2h1.984l1.482-7.747,3.87,8.3,3.868-8.3,1.482,7.745H330.9Z",
    transform: "translate(-246.955 -214.045)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M351.187,214.953V229.11l-1.984-2.081-7.659-8.035V228.2h-1.984V214.045l1.984,2.083,7.659,8.035v-9.21Z",
    transform: "translate(-217.331 -214.045)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M359.6,214.446h-8v1.984h3.009v11.263h1.984V216.43H359.6Z",
    transform: "translate(-202.046 -213.537)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M292.154,199.783H285.7V227.19h4.106v-11.11h2.344a9.763,9.763,0,0,0,6.132-1.993,7.572,7.572,0,0,0,2.76-6.155C301.046,202.368,296.655,199.783,292.154,199.783Zm3.366,11.432a5.4,5.4,0,0,1-3.27,1h-2.44v-8.559h2.44c2.36,0,4.771,1.146,4.771,4.28A3.927,3.927,0,0,1,295.52,211.215Z",
    transform: "translate(-285.704 -199.209)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M321.074,199.783h-7.469V227.19h7.469a13.419,13.419,0,0,0,13.7-13.7C334.778,205.1,328.641,199.783,321.074,199.783Zm-1.008,23.54h-2.358V203.65h2.358c5.431,0,10.579,2.871,10.579,9.836C330.645,220.048,325.5,223.323,320.066,223.323Z",
    transform: "translate(-250.282 -199.209)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M334.68,199.783h-7.467V227.19h7.467a13.419,13.419,0,0,0,13.7-13.7C348.384,205.1,342.247,199.783,334.68,199.783Zm-1.008,23.54h-2.358V203.65h2.358c5.431,0,10.579,2.871,10.579,9.836C344.251,220.048,339.1,223.323,333.672,223.323Z",
    transform: "translate(-233.005 -199.209)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M311.023,199.53a14.278,14.278,0,1,0,14.28,14.278A14.28,14.28,0,0,0,311.023,199.53Zm0,24.67a10.4,10.4,0,1,1,10.145-10.392A10.272,10.272,0,0,1,311.023,224.2Z",
    transform: "translate(-271.689 -199.53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M370.592,227.19h5.032l-8.3-11.514a8.711,8.711,0,0,0,3.146-1.589,7.573,7.573,0,0,0,2.76-6.155c0-5.565-4.392-8.15-8.892-8.15h-6.45V227.19H362v-11.11h1ZM362,203.653h2.438c2.363,0,4.773,1.146,4.773,4.28a3.927,3.927,0,0,1-1.5,3.282,5.406,5.406,0,0,1-3.273,1H362Z",
    transform: "translate(-194.057 -199.209)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(125.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M347.079,209.183v6.075h-6.248l3.088-6.075Z",
    transform: "translate(-340.832 -186.554)",
    fill: "#af76aa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 6.156,
    height: 6.075,
    transform: "translate(7.708 22.629)",
    fill: "#af76aa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 6.154,
    height: 6.075,
    transform: "translate(15.324 22.629)",
    fill: "#af76aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M357.187,215.257h-6.248v-6.075h3.16Z",
    transform: "translate(-328 -186.554)",
    fill: "#af76aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M353.356,211.2h-2.418v-4.756Z",
    transform: "translate(-328 -190.031)",
    fill: "#801d77"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 6.154,
    height: 6.082,
    transform: "translate(15.324 15.087)",
    fill: "#801d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M352.085,205.294H345.9l3.093-6.082Z",
    transform: "translate(-334.398 -199.212)",
    fill: "#4d184e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M353.738,208.533v.087h-6.154v-6.085h3.1Z",
    transform: "translate(-332.259 -194.993)",
    fill: "#661a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M350.384,202.535v6.085h-6.156v-.082l3.051-6Z",
    transform: "translate(-336.52 -194.993)",
    fill: "#661a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M344.937,206.445V211.2h-2.418Z",
    transform: "translate(-338.689 -190.029)",
    fill: "#801d77"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 6.156,
    height: 6.082,
    transform: "translate(7.708 15.087)",
    fill: "#801d77"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.35feff5e4e029b9c37e6aab1172837e2.svg";
export { ForwardRef as ReactComponent };